var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'error-border': _vm.errorBorder }},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('editor',{key:"default",attrs:{"value":_vm.value,"init":_vm.initEditorSettings,"tinymce-script-src":_vm.tinyMceScript},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }